import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isExist, isEmpty, serializeQuery, deserializeQuery, removeParams } from "cxa-utils";
import { compose } from "ramda";
import PreBoot from "./PreBoot";
import { setLanguageByCode } from "../actions/localizationActions";
import { loadClientSettings, loadCustomCss } from "../actions/commonActions";
import { getQueryParamFromLocation } from "../utils";
import { showToast } from "../actions/toastActions";

const mapStateToProps = ({ app, localization, login, common }) => {
  const { clientName, client } = app;
  const { clientSettings, customCss, customCssError } = common;

  return {
    clientName,
    client,
    localization,
    login,
    clientSettings,
    customCss,
    customCssError,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLanguage: () => {
      const { location, history } = ownProps;
      const { pathname, search } = location;
      const parsedQuery = deserializeQuery(search);
      const { langid = "" } = parsedQuery;

      dispatch(setLanguageByCode(langid)).then(() => {
        if (isExist(langid)) {
          const query = compose(
            serializeQuery,
            removeParams(["langid"])
          )(parsedQuery);

          history.replace(`${pathname}${isExist(query) ? `?${query}` : ""}`);
        }
      });
    },

    doLoadClientSettings: ({ clientSettings, clientName }) => {
      if (isExist(clientName) && isEmpty(clientSettings)) {
        const toastMsg = getQueryParamFromLocation("toast");
        toastMsg && dispatch(showToast({ message: toastMsg }));
        dispatch(loadClientSettings(clientName));
      }
    },

    loadCustomCss: clientName => dispatch(loadCustomCss(clientName)),
  };
};

const PreBootContainer = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(PreBoot);

export default PreBootContainer;



// WEBPACK FOOTER //
// ./components/PreBootContainer.js